import { Box, Button, Grid, Hidden, Stack, Typography, useTheme } from "@mui/material";
import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { CountryCustom, NumbericInputCustom, SelectCustom, TextFieldCustom } from "../../components/FormElements";
import { config_path } from "../../router/config.path";
import validators from '../../utils/validators';
import PublicPage from "../PublicPage";
import { BackIcon } from "../../components/IconComponent";
import { replaceParamTranslation } from "../../utils/util";
import { useNavigate } from "react-router-dom";
import { cache } from "../../utils/cache";
import crmservices from "../../wsclient";
import InitiatePage from "../InitiatePage";

export default function WalletLinkView(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { palette } = useTheme();
    const { type, value, calling_countries, calling_country_default, calling_country } = props;
    const isAlreadyWallet = cache.getIsAlreadyWallet();
    const session = crmservices.getSession() ? crmservices.getSession() : null;
    const organisationName = session ? session.current_organisation_name : null;
    const windowWidth = window.innerWidth
    
    let walletLinkTypes = [
        {
            label: "Email",
            value: 'EMAIL',
        },
        {
            label: "Phone",
            value: 'PHONE',
        }
    ]

    const onBack = ()=>{
        navigate(config_path.register);
    }

    let optionsColour = null;
    if (palette.secondary.background.startsWith('#fff') || palette.secondary.background.startsWith('#000') ) 
    {
        optionsColour = palette.primary.main;
    }
    else if(palette.primary.main === palette.secondary.background)
    {
        optionsColour = '#ffffff'
    }
    else{
        optionsColour = palette.primary.main;
    }

    const renderContent = () => {

    return (
        <>
            {type === 'link' &&
                <Stack onClick={onBack} style={{ cursor: 'pointer',position:"absolute",top:16,left:10 }} >
                    <BackIcon color={optionsColour}/>
                </Stack>
            }
            <Box
                sx={{
                    position: {xs:'absolute', md: 'inherit'},
                    bottom: {xs:'0px', md: undefined},
                    backgroundColor: palette.background.paper,
                    borderRadius: '20px 20px 0px 0px',
                    p: 3, 
                    color: 'white', 
                    width: '100%',
                }}>
            
            {type === 'main' ? <Grid item xs={12} container justifyContent='center' marginTop={{xs:2,md:5}}>
                <Grid item xs={12}>
                    <Grid item xs={12} container justifyContent={'center'}>
                        <Typography variant="h5" textAlign={'center'}>{t('wallet_information')}</Typography>
                    </Grid>
                    <Grid item xs={12} container justifyContent={'center'} marginTop={4}>
                        <Typography sx={{fontSize:"0.9em"}} textAlign={'center'}>
                            {isAlreadyWallet ? 
                                replaceParamTranslation(t('already_wallet_link_desc'), [organisationName, organisationName]) :
                                replaceParamTranslation(t('create_new_wallet_desc'), [organisationName])
                            }
                        </Typography>
                    </Grid>
                    <Grid item xs={12} container spacing={2} marginTop={4}>
                        <Grid item xs={12} sx={{display: 'flex', justifyContent: 'center'}}>
                            {isAlreadyWallet ?
                            <Button sx={{ width: {xs: '100%', md: '50%'}}} variant="contained" id="walletLink/New" onClick={() => props.onLinkWallet()}>{t('okay')}</Button>     
                            :
                            <Button sx={{ width: {xs: '100%', md: '50%'}}} variant="contained" id="walletLink/New" onClick={() => props.onCreateWallet()}>{t('okay')}</Button>     

                            }                  
                        </Grid>
                        <Grid item xs={12} sx={{display: 'flex', justifyContent: 'center'}}>
                            <Button onClick={() => props.setType('link')}>{t('link wallet with another account')}</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid> :
            <Box>
                <Hidden mdDown>
                    <Stack onClick={onBack} style={{ cursor: 'pointer',position:"absolute",top:16,left:10 }} >
                        <BackIcon />
                    </Stack>
                </Hidden>

                <Grid item xs={12} container justifyContent='center'>
                <Grid item xs={12} marginTop={{xs:1,md:4}}>
                    <Typography variant='h4' textAlign={{xs:"left",md:'center'}}>{t('link_wallet_title')}</Typography>
                    <Typography variant="body2" marginTop={2}>{t('link_wallet_desc')}</Typography>
                    <Grid item xs={12} marginTop={2}>
                        <Form
                            onSubmit={props.onContinue}
                            render={({ handleSubmit, form }) => (
                                <Grid item xs={12}>
                                    <Grid item xs={12} marginY={2}>
                                        <Field
                                            name="type"
                                            isValid={true}
                                            placeholder={" "}
                                            component={SelectCustom}
                                            selectData={walletLinkTypes}
                                            isEdit={true}
                                            defaultValueSelect={'EMAIL'}
                                            valueSelect={props.identityValue}
                                            onSelectedChange={(e) => {
                                                props.onChangeIdentity(e.target.value);
                                                form.change('value', null);
                                            }}                                        
                                        />
                                    </Grid>
                                    <Grid item xs={12} marginY={2}>
                                        <Stack direction={"row"} gap={1} alignItems={"center"}>
                                            {
                                                props.identityValue === 'PHONE' && <Box flex={2}>
                                                    <Field
                                                        name="calling_country"
                                                        component={CountryCustom}
                                                        noPlaceholder={false}
                                                        noMargin={true}
                                                        isEdit={true}
                                                        // isHideLabel={true}
                                                        selectData={calling_countries}
                                                        defaultValueSelect={calling_country_default ? calling_country_default.value : null}
                                                        valueSelect={calling_country.value}
                                                        onSelectedChange={(event) => props.onSelectCountry('calling_country', event.target.value)}
                                                        onlyFlag={windowWidth < 768 ? true : false}
                                                    />
                                                </Box>
                                            }

                                            {props.identityValue === 'PHONE' &&
                                                <Box flex={3}>
                                                    <Field
                                                        name="value"
                                                        component={NumbericInputCustom}
                                                        formatType='numeric'
                                                        placeholder={t('enter_your_phone_number')}
                                                        isEdit={true}
                                                        validate={validators.composeValidators(validators.required)}
                                                        defaultValue={null}
                                                    />
                                                </Box>
                                            }

                                            {props.identityValue === 'EMAIL' &&
                                                <Box flex={3}>
                                                    <Field
                                                        name="value"
                                                        component={TextFieldCustom}
                                                        placeholder={t('email_input_placeholder')}
                                                        isEdit={true}
                                                        validate={validators.composeValidators(validators.required)}
                                                        defaultValue={null}
                                                    />
                                                </Box>
                                            }
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={12} marginY={3} marginTop={4}>
                                        <Button id="walletLink/btnSubmit" fullWidth variant='contained' onClick={handleSubmit}>Continue</Button>
                                    </Grid>
                                </Grid>
                            )}
                        />
                    </Grid>
                </Grid>
            </Grid>
            </Box>
             }
             </Box>
        </>
    )}

    return (
        <>
            <Hidden mdUp>
                <InitiatePage message={props.message} showProcessing={props.showProcessing} confirm={props.confirm} showLanguage useConfiguredLanguage>
                    {renderContent()}
                </InitiatePage>
            </Hidden>

            <Hidden mdDown>
                <PublicPage message={props.message} showProcessing={props.showProcessing} confirm={props.confirm} showLanguage useConfiguredLanguage>
                    {renderContent()}
                </PublicPage>
            </Hidden>
        </>
        
    )
}